<template>
<div>
  <div class="mo_list">
    <!--监测点状态-->
    <div class="common_item">
      <div class="name_type">监测点状态</div>
      <div class="container_charts" :style="{height:leftHeight+'px'}">
        <div class="No" :style="{height:leftHeight+'px'}" :class="{'disabledNone':monitordefault == 2}" >
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
        <div id="monitor_type" :style="{height:leftHeight+'px'}"  :class="{'disabledNone':monitordefault == 1}"> 
        </div>
      </div>
    </div>


    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>

  </div>

    <!--实时监测信息-->
  <div class="mo_list" :class="{'disabledNone':swiperDefault == 2}">
    <div class="common_item">
      <div class="name_type" v-show="ISbureau == 'true'">实时监测统计</div>
      <div class="name_type" v-show="ISbureau == 'false'">实时监测信息</div>
      <div class="monitor_info innineNO" :style="{height:leftHeight+2+'px'}">
          <div class="No" :style="{height:leftHeight+2+'px'}"  >
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>
      </div>
    </div>

    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>

    <!--实时监测统计-->
  <!-- <div class="mo_list" :class="{'disabledNone':swiperDefault == 1}" v-show="ISbureau == 'true'">
    <div class="common_item">
      <div class="name_type">实时监测统计</div>
         <div id="real_type" :style="{height:leftHeight+'px'}"></div>
    </div>

    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div> -->

    <!--实时监测信息-->
  <div class="mo_list" :style="{height:leftHeight+37+'px'}"  :class="{'disabledNone':swiperDefault == 1}">
    
    <div class="common_item" v-show="ISbureau == 'true'">
      <div class="name_type">实时监测统计</div>
      <div class="container_charts" :style="{height:leftHeight+'px'}">
        <div id="real_type" :style="{height:leftHeight+'px'}"></div>
      </div>
    </div>
    
    <div class="common_item" v-show="ISbureau == 'false'">
      <div class="name_type">实时监测信息</div>
    <!-- 告警大于六条 -->
    <!-- otherCurrentData.length>6 -->
    <div class="swiper_Wrap monitor_info" :style="{height:leftHeight+'px'}" v-if="otherCurrentData.length>6">
      <div class="monitor_info" :style="{height:leftHeight+listNormalHeight+'px'}" id="con1" ref="con1" :class="{anim:animate==true}">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
      </div>
    </div>
      <!-- 告警加正常小于6条 -->
     <div class="monitor_info" :style="{height:leftHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length<=6" id="con1" ref="con1">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>

        <div class="normal_item"  v-for="(otherItem,index) in normalCurrentData" :key="'info2-'+index" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
    </div>

    <!-- 告警加正常大于6条  告警等于6条 -->
     <div class="monitor_info" :style="{height:leftHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length>6 && otherCurrentData.length==6" id="con1" ref="con1">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
              <span class="icon_name">{{otherItem.monitorType}}</span>
            </span>
            <span v-if="otherItem.customerNameWidth<150" class="item_name" style="cursor: pointer;">{{otherItem.customerName}}</span>
              <span class="item_name" style="cursor: pointer;">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>
    </div>

    <!-- 告警加正常大于6条告警小于六条 -->
     <div class="monitor_info" :style="{height:leftHeight+'px'}" v-if="otherCurrentData.length + normalCurrentData.length>6&&otherCurrentData.length<6">
        <div class="normal_item"  v-for="(otherItem,otherIndex) in otherCurrentData" :key="otherIndex" :style="{height:listNormalHeight+'px'}">
          <div class="info_item" @click="rote(otherItem)">
            <span class="icon_size">
              <i class="icon_type">
                <img :src="otherItem.imgSrc" alt="">
              </i>
            </span>
            <span class="item_name">{{otherItem.thingjsName}}</span>
            <span class="info_type" v-html="otherItem.monitoringStatus"></span>
          </div>
        </div>

         <div class="swiper_Wrap monitor_info " :style="{height:leftHeight+'px'}" >
           <div class="monitor_info" :style="{height:leftHeight+listNormalHeight+'px'}" id="con1" ref="con1" :class="{anim:animate==true}">
            <div class="normal_item"  v-for="(otherItem,index) in normalCurrentData" :key="'info2-'+index" :style="{height:listNormalHeight+'px'}">
              <div class="info_item" @click="rote(otherItem)">
                <span class="icon_size">
                  <i class="icon_type">
                    <img :src="otherItem.imgSrc" alt="">
                  </i>
                </span>
                <span class="item_name">{{otherItem.thingjsName}}</span>
                <span class="info_type" v-html="otherItem.monitoringStatus"></span>
              </div>
            </div>
          </div>
        </div>
    </div>
   </div>
 
  <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>
  

  <div class="mo_list" style='margin-top: 10px;position:relative;'>


    <!-- this.spanScrollTrue = 2 -->
    <marquee class="marqueeS1" :class="{'disabledNone':alarmTypedefault == 1}"  v-if='spanScrollTrue==2' onMouseOver="this.stop()" onMouseOut="this.start()">
      <p v-for="(item,index) in spanScrollArr" :key="index" class='alarmScroll_W' ref='spanScroll'><span class='alarmScroll_color' :style="{backgroundColor:item.color}"></span><span style='margin-left:10px'>{{item.name}}</span></p>
    </marquee>

    <div class="marqueeS1" :class="{'disabledNone':alarmTypedefault == 1}"  v-if='spanScrollTrue==1'>
      <p v-for="(item,index) in spanScrollArr" :key="index" class='alarmScroll_W' ref='spanScroll'><span class='alarmScroll_color' :style="{backgroundColor:item.color}"></span><span style='margin-left:10px'>{{item.name}}</span></p>

    </div>
    <div class="common_item" style="overflow: inherit;">
      <div class="name_type">
        <span>报警统计</span>
        <span class="select_type">
          <span :class="{'no_select':isSelect}" style="padding-right: 10px" v-show="ISbureau == 'true'">报警个数</span>
          <span :class="{'no_select':isSelect}" style="padding-right: 10px" v-show="ISbureau == 'false'">报警次数</span>
          <span :class="{'no_select':!isSelect}">报警类型</span>
        </span>
      </div>
      <div class="container_charts" :style="{height:leftHeight+'px'}">

        <div class="No" :style="{height:leftHeight+'px'}" :class="{'disabledNone':alarmTypedefault == 2}" >
            <img src="../../../static/img/Nodata.png">
            <span>暂无数据</span>
        </div>

        <div id="warning_type1" class="innineNO" v-show="isSelect" :style="{height:leftHeight+'px'}"  :class="{'disabledNone':alarmTypedefault == 1}">
        </div>
        <div id="warning_type2" v-show="!isSelect" :style="{height:leftHeight+'px'}"  :class="{'disabledNone':alarmTypedefault == 1}">
        </div>
      </div>

    </div>

    <div class="image-border image-border1"></div>
    <div class="image-border image-border2"></div>
    <div class="image-border image-border3"></div>
    <div class="image-border image-border4"></div>
  </div>


</div>  
</template>

<script>
import {ajaxFuncJson} from '@/api/ajax';
import { parseTime } from '@/utils';
export default {
  components: {
    // refresh,//注册上拉加载组件
  },
  //接收父组件websocket推送通知
  props: {},    
  name: 'mapLeft',
  data () {
    return {
      ISbureau:sessionStorage.getItem('ISbureau'),
      userType: sessionStorage.getItem('userType') ,
      monitorTypeChart:'',
      monitorTypeChart2:'',
      swiperOption: {
        direction : 'vertical',
        init:false,
        slidesPerView: 6,
        autoplay:true,
        loop:true,
        notNextTick: true,
      },
      warnNum:3,
      windowResize:null,
      clearMonitor:null,   //监测点图表定时器
      clearInfo:null,   //实时监测信息定时器
      monitorData:[],
      monitordefault:1,//监测点状态缺省页显示与否
      swiperDefault:1,//实时监测信息缺省页显示与否
      
      normalCurrentData:[],    //正常的实时监测信息
      otherCurrentData:[],     //非正常的实时监测信息
      leftHeight:'',    //左侧容器高度
      listNormalHeight:'',
      animate:false,


      isSelect:true,
      warningTypeData:[],    //告警类型
      alarmTypedefault:1,//告警统计缺省页显示与否
      warningNumberData:[],  //告警次数
      warningName:[],   //告警机构学校名称集合
      warningLineName:[],
      clearWarningTotal:null,
      spanScrollArr:[],//告警统计头部
      spanScrollTrue:1,//告警统计头部

      yearOnYearData:[],//告警统计移入数据
    }
  },
  created() {
      var params;
        if(sessionStorage.getItem("userType") == 0){
          params=this.customerId;
        }else{
          // 校企端
          params = sessionStorage.getItem("customerId");
        }
      this.getMonitorDataAjax(params);  //监测点状态

      this.getCurrentInfo(params);    //获取实时监测信息
    
    this.getWarningTotal(params);   //告警统计图表
  },
  computed: {
    customerId() {
      return this.$store.state.bigScreenBuildingId;   //建筑id
    },
  },
  mounted(){
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    let that = this;
    that.windowResize=function () {
      that.leftHeight=(document.body.offsetHeight-287 -10)/3;
      that.listNormalHeight=(document.body.offsetHeight-287)/18;
      that.initFont();
    };
    that.windowResize();
    window.addEventListener('resize',that.windowResize);
  },
  watch: {
      customerId(val){
        this.otherCurrentData = [];
        this.animate = false;
        // clearTimeout(this.clearMonitor);
        
        // clearTimeout(this.clearInfo);

        // clearTimeout(this.clearWarningTotal);
        clearInterval(this.clearMonitor);
        
        clearInterval(this.clearInfo);

        clearInterval(this.clearWarningTotal);
        if(val){
          this.getMonitorDataAjax(val);
          this.getCurrentInfo(val);
          this.getWarningTotal(val);   //告警统计图表
        }else {
          this.getMonitorDataAjax('');
          this.getCurrentInfo('');
          this.getWarningTotal('');   //告警统计图表
        }
      }
  },
  methods:{
    getLeft3D(){
      console.log('shuxin')
      this.ISbureau = sessionStorage.getItem('ISbureau');
      if(this.ISbureau == 'true'){
        this.swiperDefault = 2;
      }
      this.getMonitorDataAjax(this.customerId);//图一
      // this.getCurrentInfo(this.customerId);    //图二
      this.getWarningTotal(this.customerId); //图三
    },
    rote(id){
      sessionStorage.setItem('saveId',id.id)
      sessionStorage.setItem('buildingId',id.buildingId)
      sessionStorage.setItem('menuS',id.buildingId)
      this.$router.push({path:'/content/monitorDetails', query:{buildingId:id.buildingId}})
    },
    // 监听到websocket变化父级调用
    watchWebsocket(val){
      this.otherCurrentData = [];
      this.animate = false;
      //  clearTimeout(this.clearMonitor);
        
      //   clearTimeout(this.clearInfo);

      //   clearTimeout(this.clearWarningTotal);
             clearInterval(this.clearMonitor);
        
        clearInterval(this.clearInfo);

        clearInterval(this.clearWarningTotal);
        if(val){
          this.getMonitorDataAjax(val);
          this.getCurrentInfo(val);
          this.getWarningTotal(val);   //告警统计图表
        }else {
          this.getMonitorDataAjax('');
          this.getCurrentInfo('');
          this.getWarningTotal('');   //告警统计图表
        }
    },

    //获取监测点状态数据-------------------------------------
     getMonitorDataAjax(val){
       if(this.userType ==3 || this.userType ==4){
         if(sessionStorage.getItem('ISbureau') == 'true'){
           ajaxFuncJson('/reginData/monitorAllStatus',{}).then(res=>{
             if(res.data.status==200){
               this.monitorData=res.data.data;
               if(this.monitorData.Data.length==0){
                 this.monitordefault = 1;
               }else{
                 this.monitordefault = 2;
               }
               let normalData = [];
               let alarmStatus = [];
               let warnStatus = [];
               let coordinateX =[];
               if(this.monitorData.Data.length>0){
                  this.monitorData.Data.forEach((a,b)=>{
                       normalData.push(a.normalData);
                       alarmStatus.push(a.alarmStatus);
                       warnStatus.push(a.warnStatus);
                       if(a.type ==1){
                          a.type = '电气';
                       }else if(a.type ==2){
                          a.type = '水压';
                       }else if(a.type ==3){
                          a.type = '液位';
                       }else if(a.type ==4){
                          a.type = '可燃气';
                       }else if(a.type ==5){
                          a.type = '烟感';
                       }else if(a.type ==6){
                          a.type = '灭火器';
                       }else if(a.type ==7){
                          a.type = '水浸';
                       }else if(a.type ==8){
                          a.type = '用传';
                       }
                       coordinateX.push(a.type);
                  })
               }
               this.setEchart('monitor_type',this.monitorData.customerName,normalData,alarmStatus,warnStatus,coordinateX);//正常 告警 预警
             }else {
               this.$message({
                 type:'error',
                 message:res.data.msg,
               })
             }
           });
         }else{
          var params={
              customerId:val,
            };
          ajaxFuncJson('/superviseIndex/monitorAllStatus',params).then(res=>{
            if(res.data.status==200){
              this.monitorData=res.data.data;
              if(this.monitorData.Data.length==0){
                 this.monitordefault = 1;
               }else{
                 this.monitordefault = 2;
               }
               let normalData = [];
               let alarmStatus = [];
               let warnStatus = [];
               let coordinateX =[];
               if(this.monitorData.Data.length>0){
                  this.monitorData.Data.forEach((a,b)=>{
                       normalData.push(a.normalData);
                       alarmStatus.push(a.alarmStatus);
                       warnStatus.push(a.warnStatus);
                       if(a.type ==1){
                          a.type = '电气';
                       }else if(a.type ==2){
                          a.type = '水压';
                       }else if(a.type ==3){
                          a.type = '液位';
                       }else if(a.type ==4){
                          a.type = '可燃气';
                       }else if(a.type ==5){
                          a.type = '烟感';
                       }else if(a.type ==6){
                          a.type = '灭火器';
                       }else if(a.type ==7){
                          a.type = '水浸';
                       }else if(a.type ==8){
                          a.type = '用传';
                       }
                       coordinateX.push(a.type);
                  })
               }
               this.setEchart('monitor_type',this.monitorData.customerName,normalData,alarmStatus,warnStatus,coordinateX);//正常 告警 预警
              // let index=0;
              // if(this.monitorData[index].empty){
              //   this.monitordefault = 1;
              // }else{
              //   this.monitordefault = 2;
              // }
              // this.setEchart('monitor_type',this.monitorData[0].customerName,this.monitorData[0].normalData,this.monitorData[0].alarmStatus,this.monitorData[0].warnStatus);//正常 告警 预警
              // this.slideMonitor(3000,res.data.data.length,index);
            }else {
              this.$message({
                type:'error',
                message:res.data.msg,
              })
            }
          });
         }
       }else{
          var params={
              customerId:val,
            };
          ajaxFuncJson('/superviseIndex/monitorAllStatus',params).then(res=>{
            if(res.data.status==200){
              this.monitorData=res.data.data;
              if(this.monitorData.Data.length==0){
                 this.monitordefault = 1;
               }else{
                 this.monitordefault = 2;
               }
               let normalData = [];
               let alarmStatus = [];
               let warnStatus = [];
               let coordinateX =[];
               if(this.monitorData.Data.length>0){
                  this.monitorData.Data.forEach((a,b)=>{
                       normalData.push(a.normalData);
                       alarmStatus.push(a.alarmStatus);
                       warnStatus.push(a.warnStatus);
                       if(a.type ==1){
                          a.type = '电气';
                       }else if(a.type ==2){
                          a.type = '水压';
                       }else if(a.type ==3){
                          a.type = '液位';
                       }else if(a.type ==4){
                          a.type = '可燃气';
                       }else if(a.type ==5){
                          a.type = '烟感';
                       }else if(a.type ==6){
                          a.type = '灭火器';
                       }else if(a.type ==7){
                          a.type = '水浸';
                       }else if(a.type ==8){
                          a.type = '用传';
                       }
                       coordinateX.push(a.type);
                  })
               }
               this.setEchart('monitor_type',this.monitorData.customerName,normalData,alarmStatus,warnStatus,coordinateX);//正常 告警 预警
              // this.slideMonitor(3000,res.data.data.length,index);
            }else {
              this.$message({
                type:'error',
                message:res.data.msg,
              })
            }
          });
       }
    },
    //轮播监测点状态图表
    // slideMonitor(controlTime,length,index){
    //   this.clearMonitor=setTimeout(()=>{
    //     index++;
    //     let currentDataIndex=index%length;

    //     if(this.monitorData[currentDataIndex].empty){
    //       this.monitordefault = 1;
    //     }else{
    //       this.monitordefault = 2;
    //     }
    //     //正常 告警 预警
    //     this.setEchart('monitor_type',this.monitorData[currentDataIndex].customerName,this.monitorData[currentDataIndex].normalData,this.monitorData[currentDataIndex].alarmStatus,this.monitorData[currentDataIndex].warnStatus);  
    //     this.slideMonitor(controlTime,length,index);
    //   },controlTime);
    // },
    setEchart(el,name,normalData,runData,faultData,typeName){
        this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
        // let cities = ['电气','水压','液位','可燃气','烟感','灭火器'];
        let cities = typeName;
        let citiesColor = [
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#d7504b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fe8463;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#607d8b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#26c0c0;"></span>',
        ]
        this.monitorTypeChart.setOption({
          color: ['#d7504b','#fe8463','#26c0c0'],
          title: {
            // top: 0,
            text:name,
            left:'center',
            textStyle: {
              color: '#27ADB1',
              fontSize: '14',
              lineHeight:'14',
              fontWeight: 'normal'
            },
          },
          tooltip : {
            show: true,
            formatter: function (params) {
              var id = params.dataIndex;
              if(params.name=='烟感' || params.name=='可燃气'|| params.name=='水浸'|| params.name=='用传'){
               return cities[id]+'<br>' + citiesColor[0]+'告警' + runData[id]+'个<br>'+ citiesColor[3]+'正常' + normalData[id]+'个<br>';
              }else{
                return cities[id]+'<br>' + citiesColor[0]+'告警' + runData[id]+'个<br>'+ citiesColor[1]+'预警' + faultData[id]+'个<br>' + citiesColor[3]+'正常' + normalData[id]+'个<br>';
              }
            },
            padding:10
          },
          legend: {
            orient:'horizontal',
            data: [
              {
                name:'告警',
                icon:'rect',
              },{
                name:'预警',
                icon:'rect',
              },{
                name:'正常',
                icon:'rect',
              }],
            itemWidth:10,
            itemHeight:10,
            top:20,
            left:'center',
            textStyle:{
              color:'#fff',
              padding:[3,15,0,0]
            }
          },
          grid: {
            top:'32%',
            left: '20',
            right: '20',
            bottom: '5%',
            containLabel: true
          },
          xAxis:  {
            type: 'category',
            data: cities,
            offset:5,
            axisTick: {
              show: false
            },
            axisLabel:{
              color:'#fff',
              interval:0,
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            }
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            axisLabel:{
              color:'#fff',
            },
            axisTick: {
              show: false
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            },
            splitLine:{
                show:true,
                lineStyle:{
                    color:'#26304e'
                }
            },
            name: '个',
            nameTextStyle: {
                color: '#fff'
            }
          },
          backgroundColor:'rgba(31,34,68,.4)',
          series: [
            {
              name: '告警',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: runData,
            },
            {
              name: '预警',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: faultData,
            },
            {
              name: '正常',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: normalData,
            }
          ]
        });
    },

    //获取实时监测信息-----------------------------------------------
    getCurrentInfo(val){
      var params={
        customerId:val,
      };
      if(this.userType == 3 || this.userType == 4){ //教育局
          if(sessionStorage.getItem('ISbureau') == 'true'){
            ajaxFuncJson('/reginData/getAlarmProcStatis',{}).then(res=>{
              if(res.data.status==200){
                this.monitorData=res.data.data;
                let index=0;
                if(this.monitorData[index].empty){
                  this.swiperDefault = 1;
                }else{
                  this.swiperDefault = 2;
                }
                let customerNameArray = [];
                let normalDataArray = [];
                let alarmStatusArray = [];
                let warnStatusArray = [];
                if(this.monitorData.length > 0){
                  this.monitorData.forEach((a,b)=>{
                    customerNameArray.push(a.customerName);
                    normalDataArray.push(a.normalData);
                    alarmStatusArray.push(a.alarmStatus);
                    warnStatusArray.push(a.warnStatus);
                  })
                }
                this.setEchart2('real_type',customerNameArray,normalDataArray,alarmStatusArray,warnStatusArray);//正常 告警 预警
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
            });
          }else {
             ajaxFuncJson('/superviseIndex/realTimeMonitorInfo3D',params).then(res=>{
                if(res.data.status==200){
                  this.otherCurrentData=[]; //告警
                  this.normalCurrentData=[]; //正常
                  // this.swiper.removeAllSlides();  //移出全部slides;
                  // normalCurrentData:[],    //正常的实时监测信息
                  // otherCurrentData:[],     //非正常的实时监测信息
                  // 告警行置顶于正常行上方；
                  // 当非正常运行行等于6条时，数据不滚动；
                  // 当非正常运行行超过6条时，数据滚动轮播，每3秒向上移动一条；
                  // 当非正常运行行小于6条时，告警行不滚动，其他行显示正常行，正常行滚动轮播，每3秒向上移动一条；

                  if(res.data.data.length == 0){
                    this.swiperDefault = 1;
                  }else{
                    this.swiperDefault = 2;
                  }
                  res.data.data.map((item,index)=>{
                    if(item.monitoringStatus == 0){
                      let rcvName = ''
                      if(item.type == 1){
                              rcvName = 'mA'
                      }else if(item.type == 2){
                        if(item.rcv != -1){
                          item.rcv = item.rcv/1000 ;
                        }
                              rcvName = 'MPa'
                      }else if(item.type == 3){
                        if(item.rcv != -1){
                          item.rcv = item.rcv/100 ;
                        }
                              rcvName = 'm'
                      }else if(item.type == 4){
                              rcvName = '正常'
                      }else if(item.type == 5){
                              rcvName = '正常'
                      }else if(item.type == 6){
                              rcvName = 'MPa'
                      }else if(item.type == 7){
                              rcvName = '正常'
                      }else if(item.type == 8){
                              rcvName = '正常'
                      }
                      if(item.type == 4||item.type == 5||item.type == 7||item.type == 8){
                        item.monitoringStatus= '<span style="color: #4caf50">'+rcvName+'</span>';
                      }else{
                        if(item.rcv == -1){
                          item.monitoringStatus= '<span style="color: #4caf50">****</span>';
                        }else{
                          item.monitoringStatus= '<span style="color: #4caf50">'+item.rcv+rcvName+'</span>';
                        }
                      }
                      // item.monitoringStatus=item.monitoringStatus.replace(/\d/g,'<span style="color: #4caf50">'+item.rcv+'</span>');

                      this.normalCurrentData.push(item);
                    }else {
                      if(item.monitoringStatus == 1){
                        if(item.type ==5){
                            if(item.rcv == 1 || item.rcv == 111){
                               item.monitoringStatus='<span style="color: #d7504b">烟雾告警</span>';
                            }else if(item.rcv == 963){
                               item.monitoringStatus='<span style="color: #d7504b">防拆告警</span>';
                            }else if(item.rcv == 986){
                               item.monitoringStatus='<span style="color: #d7504b">高温告警</span>';
                            }
                        }else{
                          item.monitoringStatus='<span style="color: #d7504b">告警</span>';
                        }
                      }
                      if(item.monitoringStatus == 2){
                        item.monitoringStatus='<span style="color: #fe8463">预警</span>';
                      }
                      this.otherCurrentData.push(item);
                    }
                    if(item.type == 1){
                        item.imgSrc = './static/img/icon_electric.png'
                    }else if(item.type == 2){
                        item.imgSrc = './static/img/icon_water.png'
                    }else if(item.type == 3){
                        item.imgSrc = './static/img/icon_level.png'
                    }else if(item.type == 4){
                        item.imgSrc = './static/img/icon_gas.png'
                    }else if(item.type == 5){
                        item.imgSrc = './static/img/icon_smoke.png'
                    }else if(item.type == 6){
                        item.imgSrc = './static/img/icon_bottol.png'
                    }else if(item.type == 7){
                        item.imgSrc = './static/img/icon_ls.png'
                    }else if(item.type == 8){
                        item.imgSrc = './static/img/icon_using.png'
                    }
                  });
                  if(this.otherCurrentData.length>6){
                    // console.log('左边告警大于6条')
                    this.clearInfo = setInterval(()=>{
                        let con1 = this.$refs.con1;
                        $('#con1').css('margin-top','-'+this.listNormalHeight+'px')
                        this.animate=!this.animate;
                        var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                        setTimeout(function(){
                            that.otherCurrentData.push(that.otherCurrentData[0]);
                            that.otherCurrentData.shift();
                            $('#con1').css('margin-top','0px')
                            that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                            // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                                  // console.log('左--------------')
                                  // console.log('左'+that.animate)
                        },500)
                    },3000);
                  }else if(this.otherCurrentData.length + this.normalCurrentData.length>6&&this.otherCurrentData.length<6){
                    this.clearInfo = setInterval(()=>{
                        let con1 = this.$refs.con1;
                        $('#con1').css('margin-top','-'+this.listNormalHeight+'px')
                        this.animate=!this.animate;
                        var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                        setTimeout(function(){
                            that.normalCurrentData.push(that.normalCurrentData[0]);
                            that.normalCurrentData.shift();
                            $('#con1').css('margin-top','0px')
                            that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                            // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                          //  console.log('左--------------')
                          //         console.log('左'+that.animate)
                        },500)
                    },3000);
                  }
                }else {
                  this.$message({
                    type:'error',
                    message:res.data.message,
                  })
                }
            });
          }
  

      }else{
              ajaxFuncJson('/superviseIndex/realTimeMonitorInfo3D',params).then(res=>{
              if(res.data.status==200){
                this.otherCurrentData=[]; //告警
                this.normalCurrentData=[]; //正常
                // this.swiper.removeAllSlides();  //移出全部slides;
                // normalCurrentData:[],    //正常的实时监测信息
                // otherCurrentData:[],     //非正常的实时监测信息
                // 告警行置顶于正常行上方；
                // 当非正常运行行等于6条时，数据不滚动；Y
                // 当非正常运行行超过6条时，数据滚动轮播，每3秒向上移动一条；
                // 当非正常运行行小于6条时，告警行不滚动，其他行显示正常行，正常行滚动轮播，每3秒向上移动一条；

                if(res.data.data.length == 0){
                  this.swiperDefault = 1;
                }else{
                  this.swiperDefault = 2;
                }
                res.data.data.map((item,index)=>{
                  if(item.monitoringStatus == 0){
                    let rcvName = ''
                    if(item.type == 1){
                            rcvName = 'mA'
                    }else if(item.type == 2){
                            if(item.rcv != -1){
                              item.rcv = item.rcv/1000 ;
                            }
                            rcvName = 'MPa'
                    }else if(item.type == 3){
                      if(item.rcv != -1){
                        item.rcv = item.rcv/100 ;
                      }
                            rcvName = 'm'
                    }else if(item.type == 4){
                            rcvName = '正常'
                    }else if(item.type == 5){
                            rcvName = '正常'
                    }else if(item.type == 6){
                            rcvName = 'MPa'
                    }else if(item.type == 7){
                              rcvName = '正常'
                      }else if(item.type == 8){
                              rcvName = '正常'
                      }
                    
                    if(item.type == 4||item.type == 5||item.type == 7||item.type == 8){
                      item.monitoringStatus= '<span style="color: #4caf50">'+rcvName+'</span>';
                    }else{
                       if(item.rcv == -1){
                          item.monitoringStatus= '<span style="color: #4caf50">****</span>';
                        }else{
                          item.monitoringStatus= '<span style="color: #4caf50">'+item.rcv+rcvName+'</span>';
                        }
                    }
                    this.normalCurrentData.push(item);
                  }else {
                    if(item.monitoringStatus == 1){
                        if(item.type ==5){
                            if(item.rcv == 1 || item.rcv == 111){
                               item.monitoringStatus='<span style="color: #d7504b">烟雾告警</span>';
                            }else if(item.rcv == 963){
                               item.monitoringStatus='<span style="color: #d7504b">防拆告警</span>';
                            }else if(item.rcv == 986){
                               item.monitoringStatus='<span style="color: #d7504b">高温告警</span>';
                            }
                        }else{
                          item.monitoringStatus='<span style="color: #d7504b">告警</span>';
                        }
                    }
                    if(item.monitoringStatus == 2){
                      item.monitoringStatus='<span style="color: #fe8463">预警</span>';
                    }
                    this.otherCurrentData.push(item);
                  }
                  if(item.type == 1){
                      item.imgSrc = './static/img/icon_electric.png'
                  }else if(item.type == 2){
                      item.imgSrc = './static/img/icon_water.png'
                  }else if(item.type == 3){
                      item.imgSrc = './static/img/icon_level.png'
                  }else if(item.type == 4){
                      item.imgSrc = './static/img/icon_gas.png'
                  }else if(item.type == 5){
                      item.imgSrc = './static/img/icon_smoke.png'
                  }else if(item.type == 6){
                      item.imgSrc = './static/img/icon_bottol.png'
                  }else if(item.type == 7){
                      item.imgSrc = './static/img/icon_ls.png'
                    }else if(item.type == 8){
                      item.imgSrc = './static/img/icon_using.png'
                    }
                });
                if(this.otherCurrentData.length>6){
                  this.clearInfo = setInterval(()=>{
                      let con1 = this.$refs.con1;
                      $('#con1').css('margin-top','-'+this.listNormalHeight+'px')
                      this.animate=!this.animate;
                      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                      setTimeout(function(){
                          that.otherCurrentData.push(that.otherCurrentData[0]);
                          that.otherCurrentData.shift();
                          $('#con1').css('margin-top','0px')
                          that.animate=false  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                         
                         // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                                  // console.log('左--------------')
                                  // console.log('左'+that.animate)
                      },500)
                  },3000);
                }else if(this.otherCurrentData.length + this.normalCurrentData.length>6&&this.otherCurrentData.length<6){
                  this.clearInfo = setInterval(()=>{
                      let con1 = this.$refs.con1;
                      $('#con1').css('margin-top','-'+this.listNormalHeight+'px')
                      this.animate=!this.animate;
                      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
                      setTimeout(function(){
                          that.normalCurrentData.push(that.normalCurrentData[0]);
                          that.normalCurrentData.shift();
                          $('#con1').css('margin-top','0px')
                          that.animate=false;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                          // that.animate=!that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                                  // console.log('左-------++-------')
                                  // console.log('左'+that.animate)
                      },500)
                  },3000);
                }
              }else {
                this.$message({
                  type:'error',
                  message:res.data.message,
                })
              }
            });
      }
    },
    setEchart2(el,name,normalData,runData,faultData){
        this.monitorTypeChart2=this.$echarts.init(document.getElementById(el));
        let cities = name;
        let citiesColor = [
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#d7504b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fe8463;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#607d8b;"></span>',
          '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#26c0c0;"></span>',
        ]
        this.monitorTypeChart2.setOption({
          color: ['#d7504b','#fe8463','#26c0c0'],
          tooltip : {
            show: true,
            formatter: function (params) {
              var id = params.dataIndex;
              return cities[id]+'<br>' + citiesColor[0]+'告警' + runData[id]+'个<br>'+ citiesColor[1]+'预警' + faultData[id]+'个<br>' + citiesColor[3]+'正常' + normalData[id]+'个<br>';
            },
            padding:10
          },
          legend: {
            orient:'horizontal',
            data: [
              {
                name:'告警',
                icon:'rect',
              },{
                name:'预警',
                icon:'rect',
              },{
                name:'正常',
                icon:'rect',
              }],
            itemWidth:10,
            itemHeight:10,
            top:20,
            left:'center',
            textStyle:{
              color:'#fff',
              padding:[3,15,0,0]
            }
          },
          grid: {
            top:'26%',
            left: '18',
            right: '35',
            bottom: '5%',
            containLabel: true
          },
          yAxis:  {
            type: 'category',
            data: cities,
            offset:5,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLabel:{
              color:'#fff',
              interval:0,
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            },
            name: '区',
            nameTextStyle: {
                color: '#fff'
            }
          },
          xAxis: {
            type: 'value',
            minInterval: 1,
            axisLabel:{
              color:'#fff',
            },
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine:{
              lineStyle: {
                color:'#0077ff'
              }
            },
            splitLine:{
                show:true,
                lineStyle:{
                    color:'#26304e'
                }
            },
            name: '个',
            nameTextStyle: {
                color: '#fff'
            }
          },
          backgroundColor:'rgba(31,34,68,.4)',
          series: [
            {
              name: '告警',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: runData,
            },
            {
              name: '预警',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: faultData,
            },
            {
              name: '正常',
              type: 'bar',
              stack: '总量',
              barWidth : 8,//柱图宽度
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: normalData,
            }
          ]
        });

    },

      //告警统计
    getWarningTotal(val){
      if(this.userType ==3 || this.userType ==4){
      let aTrue = 0;
      if(sessionStorage.getItem('ISbureau') == 'true'){
        ajaxFuncJson('/reginData/alarmTypeAndCount',{}).then(res=>{
          if(res.data.status==200){
            this.warningTypeData=[];
            this.warningName=[];
            this.warningNumberData=[];
            this.warningLineName=[];
            this.spanScrollArr=[];
            res.data.data.forEach((item,index)=>{
              var colorAry=['#26c0c0','#fe8463','#fad860','#d7504b','#607d8b',"#ff4c59","#0066ff","#FF0000"];
              var aaa = [];
              var bbb = [];
              var ccc = [];
              this.ddd=[];
                item.alarmType.forEach((item1,index)=>{
                  item1.typePercent = (item1.typePercent*100).toFixed(2);
                  aaa.push(item1.typePercent)
                       if(item1.type ==1){
                          item1.type = { name: '电气',max:100};
                       }else if(item1.type ==2){
                          item1.type = { name: '水压',max:100};
                       }else if(item1.type ==3){
                          item1.type = { name: '液位',max:100};
                       }else if(item1.type ==4){
                          item1.type = { name: '可燃气',max:100};
                       }else if(item1.type ==5){
                          item1.type = { name: '烟感',max:100};
                       }else if(item1.type ==6){
                          item1.type = { name: '灭火器',max:100};
                       }else if(item1.type ==7){
                          item1.type = { name: '水浸',max:100};
                       }else if(item1.type ==8){
                          item1.type = { name: '用传',max:100};
                       }
                        this.ddd.push(item1.type);
                })
                // 环比
                item.linkRelative.forEach((item1,index)=>{
                  item1 = (item1*100).toFixed(2);
                  bbb.push(item1)
                })
                // 同比
                item.yearOnYear.forEach((item1,index)=>{
                  item1 = (item1*100).toFixed(2);
                  ccc.push(item1)
                })
                if(item.empty){
                  aTrue++
                }
  
                item.alarmType = aaa;
                item.linkRelative = bbb;
                item.yearOnYear = ccc;
                let options={
                  value:item.alarmType,
                  name:item.customerName,
                  areaStyle:{
                    normal: {
                      opacity: .2,
                    }
                  },
                };
                let lineOptions={
                  type:'line',
                  name:item.customerName,
                  data:item.alarmCount,
                  symbol: 'circle',     //设定为实心点
                  symbolSize: 6,   //设定实心点的大小
                  hoverAnimation: false,
                  itemStyle : {
                  normal : {
                      lineStyle:{
                              width:1,//折线宽度
                          }
                      }
                  },
                  emphasis:{
                    itemStyle:{
                      color:colorAry[index%5],
                    }
                  }
                };
                let lineOptionName={
                  name:item.customerName,
                  icon:'rect',
                };
                let lineColor={
                  name:item.customerName,
                  color:colorAry[index%5],
                };
  
  
                this.warningTypeData.push(options);
                this.warningName.push(lineOptionName);
                this.warningNumberData.push(lineOptions);
                this.warningLineName.push(lineOptionName);
                this.spanScrollArr.push(lineColor);
            });
            if(aTrue==this.warningTypeData.length){
              this.alarmTypedefault = 1;
              return;
            }else{
              this.alarmTypedefault = 2;
            }
            clearTimeout(this.clearWarningTotal); 
            let index=0;
            this.$forceUpdate()
            this.setWarnEchart('warning_type1',this.ddd);
            this.setWarnLineEcharts('warning_type2','个');
            this.slideWarningEcharts(10000,index);
  
            this.$nextTick(() => {
              let widthNum = 0;
              this.$refs.spanScroll.forEach((item,index)=>{
                widthNum+= item.offsetWidth;
              })
  
              if(this.spanScrollArr.length*20+widthNum>=320){
                 this.spanScrollTrue = 2
              }else{
                this.spanScrollTrue = 1
              }
             
            })
            this.yearOnYearData = res.data.data;
          }else {
            this.$message({
              type:'error',
              message:res.data.msg,
            })
          }
        })
      }else{
            var params={
              customerId:val,
            };
            let aTrue = 0;
            ajaxFuncJson('/superviseIndex/alarmTypeAndCount',params).then(res=>{
              if(res.data.status==200){
                this.warningTypeData=[];
                this.warningName=[];
                this.warningNumberData=[];
                this.warningLineName=[];
                this.spanScrollArr=[];
                res.data.data.forEach((item,index)=>{
                  var colorAry=['#26c0c0','#fe8463','#fad860','#d7504b','#607d8b',"#ff4c59","#0066ff","#FF0000"];
                  var aaa = [];
                  var bbb = [];
                  var ccc = [];
                     this.ddd=[];
                     if(item.alarmType.length >0){
                       item.alarmType.forEach((item1,index)=>{
                         item1.typePercent = (item1.typePercent*100).toFixed(2);
                         aaa.push(item1.typePercent)
                              if(item1.type ==1){
                                 item1.type = { name: '电气',max:100};
                              }else if(item1.type ==2){
                                 item1.type = { name: '水压',max:100};
                              }else if(item1.type ==3){
                                 item1.type = { name: '液位',max:100};
                              }else if(item1.type ==4){
                                 item1.type = { name: '可燃气',max:100};
                              }else if(item1.type ==5){
                                 item1.type = { name: '烟感',max:100};
                              }else if(item1.type ==6){
                                 item1.type = { name: '灭火器',max:100};
                              }else if(item1.type ==7){
                                 item1.type = { name: '水浸',max:100};
                              }else if(item1.type ==8){
                                 item1.type = { name: '用传',max:100};
                              }
                               this.ddd.push(item1.type);
                       })
                     }else{
                       
                     }
                    // 环比
                    item.linkRelative.forEach((item1,index)=>{
                      item1 = (item1*100).toFixed(2);
                      bbb.push(item1)
                    })
                    // 同比
                    item.yearOnYear.forEach((item1,index)=>{
                      item1 = (item1*100).toFixed(2);
                      ccc.push(item1)
                    })
                    if(item.empty){
                      aTrue++
                    }else{
                      // this.alarmTypedefault = 2;
                    }
      
                    item.alarmType = aaa;
                    item.linkRelative = bbb;
                    item.yearOnYear = ccc;
                    let options={
                      value:item.alarmType,
                      name:item.customerName,
                      areaStyle:{
                        normal: {
                          opacity: .2,
                        }
                      },
                    };
                    let lineOptions={
                      type:'line',
                      name:item.customerName,
                      data:item.alarmCount,
                      symbol: 'circle',     //设定为实心点
                      symbolSize: 6,   //设定实心点的大小
                      hoverAnimation: false,
                      itemStyle : {
                      normal : {
                          lineStyle:{
                                  width:1,//折线宽度
                              }
                          }
                      },
                      emphasis:{
                        itemStyle:{
                          color:colorAry[index%5],
                        }
                      }
                    };
                    let lineOptionName={
                      name:item.customerName,
                      icon:'rect',
                    };
                    let lineColor={
                      name:item.customerName,
                      color:colorAry[index%5],
                    };
      
      
                    this.warningTypeData.push(options);
                    this.warningName.push(lineOptionName);
                    this.warningNumberData.push(lineOptions);
                    this.warningLineName.push(lineOptionName);
                    this.spanScrollArr.push(lineColor);
                });
                if(aTrue==this.warningTypeData.length){
                  this.alarmTypedefault = 1;
                  return;
                }else{
                  this.alarmTypedefault = 2;
                }
                clearTimeout(this.clearWarningTotal); 
                let index=0;
                this.$forceUpdate()
                this.setWarnEchart('warning_type1',this.ddd);
                this.setWarnLineEcharts('warning_type2','次');
                this.slideWarningEcharts(10000,index);
      
                this.$nextTick(() => {
                  let widthNum = 0;
                  this.$refs.spanScroll.forEach((item,index)=>{
                    widthNum+= item.offsetWidth;
                  })
      
                  if(this.spanScrollArr.length*20+widthNum>=320){
                    this.spanScrollTrue = 2
                  }else{
                    this.spanScrollTrue = 1
                  }
                
                })
                this.yearOnYearData = res.data.data;
              }else {
                this.$message({
                  type:'error',
                  message:res.data.msg,
                })
              }
            })
      
      }
      }else{

        var params={
          customerId:val,
        };
        let aTrue = 0;
        ajaxFuncJson('/superviseIndex/alarmTypeAndCount',params).then(res=>{
          if(res.data.status==200){
            this.warningTypeData=[];
            this.warningName=[];
            this.warningNumberData=[];
            this.warningLineName=[];
            this.spanScrollArr=[];
            res.data.data.forEach((item,index)=>{
              var colorAry=['#26c0c0','#fe8463','#fad860','#d7504b','#607d8b',"#ff4c59","#0066ff","#FF0000"];
              var aaa = [];
              var bbb = [];
              var ccc = [];
                  this.ddd=[];
                item.alarmType.forEach((item1,index)=>{
                  item1.typePercent = (item1.typePercent*100).toFixed(2);
                  aaa.push(item1.typePercent)
                       if(item1.type ==1){
                          item1.type = { name: '电气',max:100};
                       }else if(item1.type ==2){
                          item1.type = { name: '水压',max:100};
                       }else if(item1.type ==3){
                          item1.type = { name: '液位',max:100};
                       }else if(item1.type ==4){
                          item1.type = { name: '可燃气',max:100};
                       }else if(item1.type ==5){
                          item1.type = { name: '烟感',max:100};
                       }else if(item1.type ==6){
                          item1.type = { name: '灭火器',max:100};
                       }else if(item1.type ==7){
                          item1.type = { name: '水浸',max:100};
                       }else if(item1.type ==8){
                          item1.type = { name: '用传',max:100};
                       }
                        this.ddd.push(item1.type);
                })
                // 环比
                item.linkRelative.forEach((item1,index)=>{
                  item1 = (item1*100).toFixed(2);
                  bbb.push(item1)
                })
                // 同比
                item.yearOnYear.forEach((item1,index)=>{
                  item1 = (item1*100).toFixed(2);
                  ccc.push(item1)
                })
                if(item.empty){
                  aTrue++
                }else{
                  // this.alarmTypedefault = 2;
                }
  
                item.alarmType = aaa;
                item.linkRelative = bbb;
                item.yearOnYear = ccc;
                let options={
                  value:item.alarmType,
                  name:item.customerName,
                  areaStyle:{
                    normal: {
                      opacity: .2,
                    }
                  },
                };
                let lineOptions={
                  type:'line',
                  name:item.customerName,
                  data:item.alarmCount,
                  symbol: 'circle',     //设定为实心点
                  symbolSize: 6,   //设定实心点的大小
                  hoverAnimation: false,
                  itemStyle : {
                  normal : {
                      lineStyle:{
                              width:1,//折线宽度
                          }
                      }
                  },
                  emphasis:{
                    itemStyle:{
                      color:colorAry[index%5],
                    }
                  }
                };
                let lineOptionName={
                  name:item.customerName,
                  icon:'rect',
                };
                let lineColor={
                  name:item.customerName,
                  color:colorAry[index%5],
                };
  
  
                this.warningTypeData.push(options);
                this.warningName.push(lineOptionName);
                this.warningNumberData.push(lineOptions);
                this.warningLineName.push(lineOptionName);
                this.spanScrollArr.push(lineColor);
            });
            if(aTrue==this.warningTypeData.length){
              this.alarmTypedefault = 1;
              return;
            }else{
              this.alarmTypedefault = 2;
            }
            clearTimeout(this.clearWarningTotal); 
            let index=0;
            this.$forceUpdate()
            this.setWarnEchart('warning_type1',this.ddd);
            this.setWarnLineEcharts('warning_type2','次');
            this.slideWarningEcharts(10000,index);
  
            this.$nextTick(() => {
              let widthNum = 0;
              this.$refs.spanScroll.forEach((item,index)=>{
                widthNum+= item.offsetWidth;
              })
  
              if(this.spanScrollArr.length*20+widthNum>=320){
                 this.spanScrollTrue = 2
              }else{
                this.spanScrollTrue = 1
              }
             
            })
            this.yearOnYearData = res.data.data;
          }else {
            this.$message({
              type:'error',
              message:res.data.msg,
            })
          }
        })
      }
    },
    //定时轮播循环告警统计图表
    slideWarningEcharts(controlTime,index){
      this.clearWarningTotal=setTimeout(()=>{
        index++;
        if(index%2===0){
          this.isSelect=true;
        }else {
          this.isSelect=false;
        }
        this.slideWarningEcharts(controlTime,index)
      },controlTime)
    },
    setWarnLineEcharts(el,Company){
      this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
      this.monitorTypeChart.setOption({
        color:['#26c0c0','#fe8463','#fad860','#d7504b','#607d8b',"#ff4c59","#0066ff","#FF0000"],
        title: {
          text:'',
          left:'center',
          textStyle: {
            color: '#27ADB1',
            fontSize: '14',
            lineHeight:'14',
            fontWeight: 'normal'
          },
        },
        tooltip: {
          show: true,
            formatter: (params)=> {
              let id = params.dataIndex+1;
              let yearOn,linkRela,yearOnNum,linkRelaNum;
              this.yearOnYearData.forEach((item,index)=>{
                if(item.customerName==params.seriesName){
                  if(item.linkRelative[params.dataIndex].includes('-')){
                    linkRela = '下降';
                    linkRelaNum = item.linkRelative[params.dataIndex].replace('-', '');
                  }else{
                    linkRela = '上涨';
                    linkRelaNum = item.linkRelative[params.dataIndex];
                  }
                  if(item.yearOnYear[params.dataIndex].includes('-')){
                    yearOn = '下降';
                    yearOnNum = item.yearOnYear[params.dataIndex].replace('-', '');
                  }else{
                    yearOn = '上涨';
                    yearOnNum = item.yearOnYear[params.dataIndex];


                  }
                  
                 
                }
              })
              if (params.seriesName.length > 8) {
                params.seriesName= params.seriesName.substring(0, 9) +'</br>' + params.seriesName.substring(9);
              } 
              return params.seriesName+'<br>'+id+'月报警：'+params.data+Company+'<br>'+'同比'+yearOn+'：'+yearOnNum+'%<br>'+'环比'+linkRela+'：'+linkRelaNum+'%';
            },
          padding:10
        },
        legend: {
          show:false,
          left:'center',
        },
        grid: {
          left: '20',
          right: '20',
          bottom: '5%',
          containLabel: true
        },
        toolbox: {
          show:false,
        },
        backgroundColor:'rgba(31,34,68,.4)',
        xAxis: {
          type: 'category',
          boundaryGap: true,
          offset:5,
          data: ['01','02','03','04','05','06','07','08','09','10','11','12月'],
          axisTick: {
            show: false
          },
          axisLabel:{
            color:'#fff',
            interval:0,
          },
          axisLine:{
            lineStyle: {
              color:'#0077ff'
            }
          }
        },
        yAxis: {
          type: 'value',
          name : Company,
          nameTextStyle: {
              color: '#fff'
          },
          axisTick: {
            show: false
          },
          axisLabel:{
            color:'#fff',
            interval:0,
          },
          axisLine:{
            lineStyle: {
              color:'#0077ff'
            }
          },
          splitLine:{
              show:true,
              lineStyle:{
                  color:'#26304e'
              }
          },
        },
        series: this.warningNumberData,
      },true)
    },
    setWarnEchart(el,typeName){
      this.monitorTypeChart=this.$echarts.init(document.getElementById(el));
      this.monitorTypeChart.setOption({
        color:['#26c0c0','#fe8463','#fad860','#d7504b','#607d8b',"#ff4c59","#0066ff","#FF0000"],
        title: {
          text:'',
          left:'center',
          textStyle: {
            color: '#27ADB1',
            fontSize: '14',
            lineHeight:'14',
            fontWeight: 'normal'
          },
        },
        tooltip: {
          //处理移入显示的数据
          formatter:function(val){
            let str=val.name;
              if (str.length > 8) {
                str= str.substring(0, 9) +'</br>' + str.substring(9);
              } 
            val.value.forEach((list,index)=>{
              typeName.forEach((a,b)=>{
                if(index == b){
                    if(a.name=='电气'){
                      str=str+'</br>'+'电气:'+list+'%';
                    }else if(a.name=='水压'){
                      str=str+'</br>'+'水压:'+list+'%';
                    }else if(a.name=='液位'){
                      str=str+'</br>'+'液位:'+list+'%';
                    }else if(a.name=='可燃气'){
                      str=str+'</br>'+'可燃气:'+list+'%';
                    }else if(a.name=='烟感'){
                      str=str+'</br>'+'烟感:'+list+'%';
                    }else if(a.name=='灭火器'){
                      str=str+'</br>'+'灭火器:'+list+'%';
                    }else if(a.name=='水浸'){
                      str=str+'</br>'+'水浸:'+list+'%';
                    }else if(a.name=='用传'){
                      str=str+'</br>'+'用传:'+list+'%';
                    }
                }
              })
            });
            return str;
          },
          padding:10
        },
        legend: {
          show:false,
           left:'center',
        },
        radar: {
          radius:'44%',
          name: {
            textStyle: {
              color: '#fff',
              borderRadius: 3,
              padding: [0, 0]
            }
          },
          indicator: typeName,
          // [
          //   { name: '电气',max:100},
          //   { name: '水压',max:100},
          //   { name: '液位',max:100},
          //   { name: '可燃气',max:100},
          //   { name: '烟感', max:100},
          //   { name: '灭火器',max:100}
          // ],
          center: ['50%','56%'],
           splitLine : {
              show : true,
              lineStyle : {
                  width : 1,
                  color : '#666666' // 图表背景网格线的颜色
              }
          },
          axisLine: {
            lineStyle: {
                color: '#666'
            }
          },
          splitArea : {
            show : true,   
            areaStyle : {
              color: ['#d72941', '#f1c35b','#99c736', '#75813b', '#4e3829',]  ,
              opacity: 0,// 图表背景网格的颜色
            }
         },

          
        },
        series: [{
          type: 'radar',
          symbol:'none',// 去掉图表中各个图区域的边框线拐点
          lineStyle:{
            opacity: .5,
          },
          // areaStyle: {normal: {}},
          //颜色  #26c0c0 #fe8463  #fad860 #d7504b #607d8b
          data :this.warningTypeData
        }]
      });
    },


    // 宽高自适应
    initFont() {
      let that = this;
      setTimeout(function(){
        that.$echarts.init(document.getElementById('monitor_type')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('real_type')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('warning_type')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('warning_type1')).resize({width: null, height: null});
        that.$echarts.init(document.getElementById('warning_type2')).resize({width: null, height: null});
      },100)
    },
  },
  destroyed(){
    let _this=this;
    window.removeEventListener("resize",_this.windowResize);
    _this.animate = false;
    // clearTimeout(_this.clearMonitor);
        
    // clearTimeout(_this.clearInfo);

    // clearTimeout(_this.clearWarningTotal);
        clearInterval(_this.clearMonitor);
        
    clearInterval(_this.clearInfo);

    clearInterval(_this.clearWarningTotal);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mo_list{
  position: relative;
  background: rgba(44,40,84,.4);
  cursor: pointer;
}

  .image-border {
	position: absolute;
	width: 20px;
	height: 20px;
}
		
.image-border1 {
	top: 0;
	left: 0;
	border-left: 1px solid #00b0ff;
	border-top: 1px solid #00b0ff;
}
		
.image-border2 {
	top: 0;
	right: 0px;
	border-right: 1px solid #00b0ff;
	border-top:1px solid #00b0ff;
}
		
.image-border3 {
	bottom: 0;
	left: 0;
	border-bottom: 1px solid #00b0ff;
	border-left: 1px solid #00b0ff;
}
		
.image-border4 {
	bottom: 0;
	right: 0px;
	border-right: 1px solid #00b0ff;
	border-bottom: 1px solid #00b0ff;
}
 .marqueeS1{
    position: absolute !important;
    top:48px;
    left:20px;
    z-index: 100;
    width: 320px;
    margin: auto;
    text-align: center;
    display: inline-block;
    color: #fff;
    white-space:nowrap;
    overflow:hidden;
  }
  .alarmScroll_W{
    display: inline-block;
    margin-left:20px;
  }
  .alarmScroll_color{
    display: inline-block;
    width:10px;
    height:10px;
    background:#26c0c0;

  }
  .swiper_Wrap{
    width:100%;
    overflow: hidden;
  }
  #box{
    
    transition: all 0.5s;
  }
  .anim{
    transition: all 0.5s;
  }

  .common_item{
    width: 360px;
    position: relative;
    border: 1px solid #264480;
    margin-bottom: 10px;
    overflow: hidden;
    .name_type{
      font-size: 14px;
      font-weight: bold;
      color: #00b0ff;
      line-height: 35px;
      padding-left: 20px;
      background: rgba(44,40,84,0.4);
      position: relative;
      .select_type{
        position: absolute;
        right: 20px;
        color: #27ADB1;
        font-size: 12px;
        font-weight: normal;
      }
      .no_select{
        color: #607d8b;
      }
    }
    .innineNO{
      background: rgba(31,34,68,.4);
    }
    .container_charts{
      position:relative; 
      // background: rgba(31,34,68,.4);
      width: 360px;
      #monitor_type{
        width: 360px;
      }
      #warning_type{
        width: 360px;
      }
      #monitor_type1 {
        height: 255px;
        width: 360px;
      }
      // 教育局-------------
     #real_type{
        width: 360px;
      }
      // 教育局---------
      .tip_info{
        position: absolute;
        width: 100%;
        bottom: 20px;
        text-align: center;
        font-size: 13px;
        color: #fff;
      }
      #line_charts{
        height: 255px;
        width: 360px;
      }
      #warning_type1{
        height: 255px;
        width: 360px;
      }
      #warning_type2{
        height: 255px;
        width: 360px;
      }
    }
    .monitor_info{
        background: rgba(31,34,68,.4);

      .monitor_container{
        height: 100%;
        .info_item{
          display: flex;
          height: 100%;
          align-items: center;
          padding: 0 20px;
          font-size: 13px;
          color: #fff;
          position: relative;
          .icon_size{
            display: inline-block;
            width: 90px;
            margin-top: 2px;
            .icon_name{
              position: relative;
              top:-4px;
            }
            .icon_type{
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .item_name{
            color: #26c0c0;
            width:150px;
            overflow:hidden;
            white-space:nowrap ;   
            text-overflow:ellipsis;
          }
          .info_type{
            position: absolute;
            right: 20px;
            width: 100px;
            text-align: right;
          }
        }
      }
      .normal_item{
        /*height: 42.5px;*/
        // background: rgba(31,34,68,.4);
        .info_item{
          display: flex;
          height: 100%;
          align-items: center;
          padding: 0 20px;
          font-size: 13px;
          color: #fff;
          position: relative;
          .icon_size{
            display: inline-block;
            width: 70px;
            margin-top: 2px;
            .icon_name{
              position: relative;
              top:-4px;
            }
            .icon_type{
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
          .item_name{
            color: #26c0c0;
            width:180px;
            overflow:hidden;
            white-space:nowrap ;   
            text-overflow:ellipsis;
          }
          .info_type{
            position: absolute;
            right: 20px;
            width: 100px;
            text-align: right;
          }
        }
      }
    }
  }
  .disabledNone{
    display: none;
  }
  .No{
    top: 69%;
  }
  .No span {
    font-size: 14px;
    color: #f5f5f5;
  }
  .No img {
    margin: 0 auto 0px;
  }
</style>



// WEBPACK FOOTER //
// src/page/home/mapLeft.vue